/* eslint-disable no-unused-vars */
import "./products-filters.scss"

import React, { useState, useEffect } from "react"
import { Field, FieldArray, Formik } from "formik"
import { useQueryParam, NumberParam } from "use-query-params"
import { useProductsFilters } from "context/products_filters"

import PageSubHeader from "components/PageSubHeader/PageSubHeader"
import Input from "components/Input/Input"
import CheckboxMark from "components/CheckboxMark/CheckboxMark"
import Button from "components/Button/Button"

let timer

const ProductsFilters = ({ className }) => {
  const { filters, query, setQuery } = useProductsFilters()
  const isBrowser = typeof window !== "undefined"
  const [mobileFilters, setMobileFilters] = useState(null)
  const [priceMin, setPriceMin] = useQueryParam("priceMin", NumberParam)
  const [priceMax, setPriceMax] = useQueryParam("priceMax", NumberParam)
  const [skip, setSkip] = useQueryParam("skip", NumberParam)

  useEffect(() => {
    if (isBrowser && window.innerWidth < 1199) {
      setMobileFilters(false)
    } else {
      setMobileFilters(true)
    }
    return () => {
      clearTimeout(timer)
    }
  }, [isBrowser])

  const onSubmit = ({ priceMin, priceMax, ...rest }) => {
    const scrollPosition =
      window.pageYOffset || document.documentElement.scrollTop

    setMobileFilters(isBrowser && window.innerWidth < 1199 ? false : true)
    setPriceMin(priceMin || undefined)
    setPriceMax(priceMax || undefined)
    setSkip(undefined)
    setQuery(rest)

    setTimeout(() => {
      window.scrollTo(0, scrollPosition)
    }, 0)
  }

  const handlePriceChange = handleSubmit => {
    const scrollPosition =
      window.pageYOffset || document.documentElement.scrollTop

    clearTimeout(timer)
    timer = setTimeout(() => {
      handleSubmit()
      setTimeout(() => {
        window.scrollTo(0, scrollPosition)
      }, 0)
    }, 500)
  }

  return (
    <>
      <div className="products-filters__mobile-cta">
        <Button
          className="button--block"
          onClick={() => setMobileFilters(!mobileFilters)}
        >
          Pokaż filtry
        </Button>
      </div>
      {mobileFilters && (
        <aside
          className={`products-filters${className ? ` ${className}` : ""}`}
        >
          <Formik
            onSubmit={onSubmit}
            initialValues={{
              priceMin,
              priceMax,
              ...query,
            }}
          >
            {({ handleSubmit, values }) => (
              <form
                onSubmit={e => {
                  e.preventDefault()
                  handleSubmit(e)
                }}
              >
                <div className="products-filters__item">
                  <PageSubHeader title="Cena" />
                  <div className="row">
                    <div className="col-6">
                      <Field
                        component={Input}
                        placeholder="Od:"
                        type="number"
                        min="1"
                        step="1"
                        name="priceMin"
                        onChange={() => handlePriceChange(handleSubmit)}
                      />
                    </div>
                    <div className="col-6">
                      <Field
                        component={Input}
                        placeholder="Do:"
                        type="number"
                        min="1"
                        step="1"
                        name="priceMax"
                        onChange={() => handlePriceChange(handleSubmit)}
                      />
                    </div>
                  </div>
                </div>
                {filters?.length > 0 &&
                  filters.map(({ id, title, options }) => (
                    <div className="products-filters__item" key={id}>
                      <PageSubHeader title={title} />
                      <div className="products-filters__group">
                        <FieldArray
                          name={id}
                          render={arrayHelpers => (
                            <div>
                              {options.map(({ name, count }) => (
                                <CheckboxMark
                                  key={name}
                                  type="checkbox"
                                  name={id}
                                  value={name}
                                  checked={values?.[id]?.includes(name)}
                                  onChange={e => {
                                    e.stopPropagation()

                                    if (e.target.checked) {
                                      arrayHelpers.push(name)
                                    } else {
                                      const idx = values[id].indexOf(name)
                                      arrayHelpers.remove(idx)
                                    }

                                    const scrollPosition =
                                      window.pageYOffset ||
                                      document.documentElement.scrollTop

                                    clearTimeout(timer)
                                    timer = setTimeout(() => {
                                      handleSubmit()

                                      setTimeout(() => {
                                        window.scrollTo(0, scrollPosition)
                                      }, 0)
                                    }, 100)
                                  }}
                                >
                                  {name} ({count})
                                </CheckboxMark>
                              ))}
                            </div>
                          )}
                        />
                      </div>
                    </div>
                  ))}
              </form>
            )}
          </Formik>
        </aside>
      )}
    </>
  )
}

export default ProductsFilters
